/** @file Animations panel commands: create, rename, duplicate, delete, length, mix default. */
import type { CommandCall, Id } from '@pose2d/format/types';

/** One command per panel action (each dispatched as its own batch); ids or names are accepted by the commands. */
export const animationCalls = {
  /** animation.create; the dispatcher (E8) mints the client id. */
  create: (name: string): CommandCall => ({ name: 'animation.create', input: { name } }),
  /** animation.rename. */
  rename: (id: Id, name: string): CommandCall => ({ name: 'animation.rename', input: { target: id, name } }),
  /** animation.duplicate under `name`. */
  duplicate: (id: Id, name: string): CommandCall => ({ name: 'animation.duplicate', input: { source: id, name } }),
  /** animation.delete. */
  remove: (id: Id): CommandCall => ({ name: 'animation.delete', input: { target: id } }),
  /** animation.setDuration in whole frames (null = back to the last key). */
  setFrames: (id: Id, frames: number | null): CommandCall => ({ name: 'animation.setDuration', input: { animation: id, frames } }),
  /** animation.setMixDefault for the pair (by name). */
  saveMix: (from: string, to: string, seconds: number): CommandCall => ({ name: 'animation.setMixDefault', input: { from, to, seconds } }),
};
